/*
  Slushy calculator: the machines, the rules and the ingredients.

  Everything a customer is told comes from this file, so it's written to be
  checked by the culinary team. Page numbers point at the user guides:
    MAX  = Slush-Ease MAX, RJ62-20A-Series_UG_DIGITAL_061325.pdf
    ORIG = Slush-Ease (original), RJ62-Series_UG_FINAL_OTP_091924.pdf

  Ingredient numbers:
    sugar  grams of sugar per fluid ounce, from typical nutrition labels
           (brands vary; the "from a label" option uses the customer's own)
    abv    alcohol by volume, %
  Flags: dairy (foams), beer (foams), protein (protein shake), diet (sugar-free
  on purpose), water (plain water or seltzer), spirit (hard liquor),
  allulose, dry (a dry ingredient: adds sugar, not liquid).
*/
window.SLUSH_DATA = {
  rules: {
    // "Your mixture must be at least 4% sugar ... the 'Total Sugars' listed on
    // the nutrition label should be 1 g of sugar for every 1 oz" (MAX p.13, ORIG p.14)
    sugarPerOz: 1,
    // Too sweet freezes soft: "Slushy is too thin ... too much alcohol, fat, or
    // sugar" (MAX troubleshooting). Neither guide gives a number; 8 g per oz is
    // culinary's interim pick, just above the sweetest mixers in the guides'
    // recipes. Past it, a tip; never the verdict.
    sweetTipPerOz: 8,
    // Alcohol over 16% won't freeze (MAX p.14, ORIG p.14)
    maxAbv: 16,
    // Beer below 2.8% ABV and low in sugar can overfreeze (MAX p.12). Above
    // this, alcohol keeps the mix from freezing solid, which is why beer, wine
    // and hard seltzer slush on their own with little sugar (MAX p.12, p.14).
    alcoholCountsFrom: 2.8,
    // Allulose syrup per serving (MAX p.14): 8 oz → ½ Tbsp, 12 oz → 1 Tbsp,
    // 20 oz → 1½ Tbsp. 16 g of sugar per Tbsp, rounded up to the next ½ Tbsp,
    // gives exactly those amounts.
    allulosePerTbsp: 16,
    sugarPerTbsp: 12.5,      // granulated sugar
    simpleSyrupPerTbsp: 8    // 1:1 simple syrup, about 16 g per fl oz
  },

  machines: {
    max: {
      name: 'Slush-Ease MAX',
      // the page reads the product's own guide link first; this is the fallback
      guide: 'https://cdn.shopify.com/s/files/1/0576/5755/7158/files/RJ62-20A-Series_UG_DIGITAL_061325_de7e0c65-e824-401c-8d40-e967e4b10e30.pdf',
      model: 'RJ62-20A',
      minOz: 16, maxOz: 64,             // MAX p.2
      foamOz: 48,                        // dairy or beer: 48 oz the first time (MAX p.18)
      holdHours: 12,                     // MAX p.11
      thickness: { kind: 'bars', of: 10 },
      // Most hard liquor for a recipe this size (MAX p.14).
      // CHECK WITH CULINARY: the 4½-cup row allows a smaller share than the
      // other two (17% vs 21–22%), which looks like a typo.
      spirits: [[24, 16 / 3], [36, 6], [48, 10]],
      thinner: 'Run Defrost for a few minutes',
      firstNote: null
    },
    orig: {
      name: 'Slush-Ease',
      guide: 'https://cdn.shopify.com/s/files/1/0576/5755/7158/files/RJ62-Series_UG_FINAL_OTP_091924.pdf',
      model: 'RJ62',
      minOz: 16, maxOz: 48,              // 48 oz max; 16 oz min is PROVISIONAL (not in the guide)
      minProvisional: true,
      foamOz: null,
      holdHours: 4,                      // ORIG p.11
      thickness: { kind: 'levels', of: 5 },
      spirits: null,
      thinner: 'Run the cleaning cycle for a few minutes',
      firstNote: null
    }
  },

  // Presets and thickness from the guides. max: bars of 10 (MAX p.12).
  // orig: a preset, "thickest" (5 of 5), or Custom at a set temperature (ORIG p.15).
  ingredients: [
    // Soft drinks
    { id: 'cola', name: 'Cola', aliases: 'coke pepsi soda pop dr pepper', group: 'Soft drinks', sugar: 3.25, abv: 0,
      max: { preset: 'Slushy', bars: 3 }, orig: { preset: 'Soft Drink' } },
    { id: 'lemon-lime', name: 'Lemon-lime soda', aliases: 'sprite 7up soda pop', group: 'Soft drinks', sugar: 3.2, abv: 0,
      max: { preset: 'Slushy', bars: 3 }, orig: { preset: 'Soft Drink' } },
    { id: 'orange-soda', name: 'Orange soda', aliases: 'fanta crush soda pop', group: 'Soft drinks', sugar: 3.6, abv: 0,
      max: { preset: 'Slushy', bars: 3 }, orig: { preset: 'Soft Drink' } },
    { id: 'root-beer', name: 'Root beer', aliases: 'a&w soda pop', group: 'Soft drinks', sugar: 3.8, abv: 0,
      max: { preset: 'Slushy', bars: 3 }, orig: { preset: 'Soft Drink' } },
    { id: 'diet-soda', name: 'Diet or zero-sugar soda', aliases: 'diet coke coke zero pepsi zero sugar free soda diet tonic light tonic slimline tonic', group: 'Soft drinks', sugar: 0, abv: 0, diet: true,
      max: { preset: 'Slushy', bars: 3 }, orig: { preset: 'Soft Drink' } },
    { id: 'energy', name: 'Energy drink', aliases: 'red bull monster', group: 'Soft drinks', sugar: 3.2, abv: 0,
      max: { preset: 'Slushy', bars: 2 }, orig: { preset: 'Soft Drink' } },
    { id: 'sports', name: 'Sports drink', aliases: 'gatorade powerade', group: 'Soft drinks', sugar: 1.7, abv: 0,
      max: { preset: 'Juice', bars: 1 }, orig: { preset: 'Custom', temp: '29–29.8°F' } },
    // Regular tonic runs about 32 g of sugar per 12 oz (Schweppes, Canada Dry); Fever-Tree is a little less.
    { id: 'tonic', name: 'Tonic water', aliases: 'tonic schweppes canada dry fever tree fever-tree q mixers seagram', group: 'Soft drinks', sugar: 2.7, abv: 0,
      max: { preset: 'Slushy', bars: 3 }, orig: { preset: 'Soft Drink' } },
    { id: 'seltzer', name: 'Club soda or seltzer', aliases: 'sparkling water soda water mineral water carbonated water fizzy perrier san pellegrino topo chico la croix lacroix bubly polar spindrift unsweetened', group: 'Soft drinks', sugar: 0, abv: 0, water: true },

    // Juices and lemonades
    { id: 'lemonade', name: 'Lemonade', aliases: 'simply', group: 'Juices & lemonades', sugar: 3.5, abv: 0,
      max: { preset: 'Slushy', bars: 4 }, orig: { preset: 'Juice', level: 5 } },
    { id: 'limeade', name: 'Limeade', aliases: 'simply', group: 'Juices & lemonades', sugar: 3.4, abv: 0,
      max: { preset: 'Slushy', bars: 4 }, orig: { preset: 'Custom', temp: '28.8–29.4°F' } },
    { id: 'oj', name: 'Orange juice', aliases: 'oj', group: 'Juices & lemonades', sugar: 2.75, abv: 0,
      max: { preset: 'Juice', bars: 4 }, orig: { preset: 'Juice' } },
    { id: 'apple', name: 'Apple juice or cider', aliases: 'apple cider', group: 'Juices & lemonades', sugar: 3.0, abv: 0,
      max: { preset: 'Juice', bars: 8 }, orig: { preset: 'Juice' } },
    { id: 'pineapple', name: 'Pineapple juice', aliases: '', group: 'Juices & lemonades', sugar: 3.1, abv: 0,
      max: { preset: 'Juice', bars: 8 }, orig: { preset: 'Juice' } },
    { id: 'cranberry', name: 'Cranberry juice cocktail', aliases: 'ocean spray', group: 'Juices & lemonades', sugar: 3.6, abv: 0,
      max: { preset: 'Juice', bars: 7 }, orig: { preset: 'Juice' } },
    { id: 'watermelon', name: 'Watermelon juice', aliases: '', group: 'Juices & lemonades', sugar: 2.0, abv: 0,
      max: { preset: 'Juice', bars: 1 }, orig: { preset: 'Juice' } },
    { id: 'grape', name: 'Grape juice', aliases: 'welchs', group: 'Juices & lemonades', sugar: 4.5, abv: 0,
      max: { preset: 'Juice', bars: 4 }, orig: { preset: 'Juice' } },
    { id: 'coconut-water', name: 'Coconut water', aliases: 'vita coco', group: 'Juices & lemonades', sugar: 1.0, abv: 0,
      max: { preset: 'Juice', bars: 4 }, orig: { preset: 'Custom', temp: '29.6°F' } },
    { id: 'lime-juice', name: 'Fresh lime or lemon juice', aliases: 'lime lemon citrus', group: 'Juices & lemonades', sugar: 0.5, abv: 0, minor: true },
    { id: 'fruit-puree', name: 'Fruit purée', aliases: 'strawberry mango puree', group: 'Juices & lemonades', sugar: 2.0, abv: 0, minor: true },

    // Tea and coffee
    { id: 'sweet-tea', name: 'Sweetened iced tea', aliases: 'sweet tea arizona gold peak', group: 'Tea & coffee', sugar: 2.7, abv: 0,
      max: { preset: 'Slushy', bars: 2 }, orig: { preset: 'Juice', level: 5 } },
    { id: 'unsweet-tea', name: 'Unsweetened iced tea', aliases: 'tea', group: 'Tea & coffee', sugar: 0, abv: 0, diet: true,
      max: { preset: 'Slushy', bars: 2 }, orig: { preset: 'Juice', level: 5 } },
    { id: 'kombucha', name: 'Kombucha (non-alcoholic)', aliases: 'gts health-ade', group: 'Tea & coffee', sugar: 1.0, abv: 0,
      max: { preset: 'Slushy', bars: 1 }, orig: { preset: 'Custom', temp: '29.8°F' } },
    { id: 'coffee-milk', name: 'Bottled coffee-and-milk drink', aliases: 'starbucks frappuccino latte', group: 'Tea & coffee', sugar: 2.6, abv: 0, dairy: true, coffee: true,
      max: { preset: 'Frappe', bars: 5 }, orig: { preset: 'Custom', temp: '28.8–29.8°F' } },
    { id: 'cold-brew', name: 'Cold brew or black coffee', aliases: 'coffee', group: 'Tea & coffee', sugar: 0, abv: 0, coffee: true },

    // Dairy and shakes
    { id: 'milk', name: 'Milk', aliases: 'whole milk 2%', group: 'Dairy & shakes', sugar: 1.5, abv: 0, dairy: true },
    { id: 'cream', name: 'Heavy cream', aliases: 'half and half', group: 'Dairy & shakes', sugar: 0, abv: 0, dairy: true },
    { id: 'oat-milk', name: 'Oat milk (sweetened)', aliases: 'oatly plant milk', group: 'Dairy & shakes', sugar: 0.9, abv: 0, dairy: true },
    { id: 'smoothie', name: 'Bottled smoothie', aliases: 'bolthouse naked', group: 'Dairy & shakes', sugar: 3.0, abv: 0,
      max: { preset: 'Shake', bars: 7 }, orig: { preset: 'Juice' } },
    { id: 'protein', name: 'Bottled protein shake', aliases: 'premier fairlife core power', group: 'Dairy & shakes', sugar: 0.1, abv: 0, dairy: true, protein: true,
      max: { preset: 'Shake', bars: 5 } },

    // Beer, wine and seltzer
    { id: 'beer', name: 'Beer (lager)', aliases: 'light beer pilsner', group: 'Beer, wine & seltzer', sugar: 0, abv: 5, beer: true,
      max: { preset: 'Cocktail', bars: 2 }, orig: { preset: 'Beer' } },
    { id: 'ipa', name: 'IPA', aliases: 'beer india pale ale', group: 'Beer, wine & seltzer', sugar: 0, abv: 7, beer: true,
      max: { preset: 'Cocktail', bars: 2 }, orig: { preset: 'Beer', level: 5 } },
    { id: 'sour-beer', name: 'Sour beer or gose', aliases: 'beer gose', group: 'Beer, wine & seltzer', sugar: 0.3, abv: 4.5, beer: true,
      max: { preset: 'Cocktail', bars: 2 }, orig: { preset: 'Beer', level: 5 } },
    { id: 'hard-seltzer', name: 'Hard seltzer', aliases: 'white claw truly', group: 'Beer, wine & seltzer', sugar: 0.1, abv: 5,
      max: { preset: 'Cocktail', bars: 1 }, orig: { preset: 'Custom', temp: '26°F' } },
    { id: 'rose', name: 'Rosé wine', aliases: 'wine frose', group: 'Beer, wine & seltzer', sugar: 0.3, abv: 12, wine: true,
      max: { preset: 'Cocktail', bars: 6 }, orig: { preset: 'Wine' } },
    { id: 'white-wine', name: 'White wine', aliases: 'wine pinot grigio sauvignon', group: 'Beer, wine & seltzer', sugar: 0.3, abv: 12, wine: true,
      max: { preset: 'Cocktail', bars: 6 }, orig: { preset: 'Wine' } },
    { id: 'port', name: 'Port or fortified wine', aliases: 'sherry', group: 'Beer, wine & seltzer', sugar: 3.0, abv: 20, wine: true },

    // Spirits and liqueurs
    { id: 'tequila', name: 'Tequila', aliases: 'mezcal liquor', group: 'Spirits & liqueurs', sugar: 0, abv: 40, spirit: true },
    { id: 'vodka', name: 'Vodka', aliases: 'liquor', group: 'Spirits & liqueurs', sugar: 0, abv: 40, spirit: true },
    { id: 'rum', name: 'Rum', aliases: 'liquor', group: 'Spirits & liqueurs', sugar: 0, abv: 40, spirit: true },
    { id: 'gin', name: 'Gin', aliases: 'liquor', group: 'Spirits & liqueurs', sugar: 0, abv: 40, spirit: true },
    { id: 'whiskey', name: 'Whiskey or bourbon', aliases: 'liquor whisky', group: 'Spirits & liqueurs', sugar: 0, abv: 40, spirit: true },
    { id: 'triple-sec', name: 'Triple sec', aliases: 'orange liqueur cointreau', group: 'Spirits & liqueurs', sugar: 7, abv: 30, spirit: true },

    // Cocktail mixers
    { id: 'margarita-mix', name: 'Margarita mixer', aliases: 'mix', group: 'Cocktail mixers', sugar: 6.5, abv: 0, mixer: true },
    { id: 'pina-colada-mix', name: 'Piña colada mixer', aliases: 'pina colada mix', group: 'Cocktail mixers', sugar: 7.5, abv: 0, mixer: true },
    { id: 'daiquiri-mix', name: 'Strawberry daiquiri mixer', aliases: 'mix', group: 'Cocktail mixers', sugar: 6.5, abv: 0, mixer: true },

    // Sweeteners
    { id: 'sugar', name: 'Granulated sugar', aliases: 'white sugar', group: 'Sweeteners', sugarPerTbsp: 12.5, abv: 0, dry: true, unit: 'Tbsp' },
    { id: 'simple-syrup', name: 'Simple syrup', aliases: 'syrup flavored syrup', group: 'Sweeteners', sugar: 16, abv: 0, unit: 'Tbsp' },
    { id: 'honey', name: 'Honey', aliases: '', group: 'Sweeteners', sugar: 34, abv: 0, unit: 'Tbsp' },
    { id: 'maple', name: 'Maple syrup', aliases: '', group: 'Sweeteners', sugar: 25, abv: 0, unit: 'Tbsp' },
    { id: 'agave', name: 'Agave nectar', aliases: '', group: 'Sweeteners', sugar: 32, abv: 0, unit: 'Tbsp' },
    { id: 'allulose', name: 'Allulose syrup', aliases: 'sugar substitute keto', group: 'Sweeteners', sugar: 32, abv: 0, allulose: true, unit: 'Tbsp' },

    // Other
    { id: 'water', name: 'Water', aliases: '', group: 'Other', sugar: 0, abv: 0, water: true }
  ],

  // The guides' own recipes and their settings. Not shown to customers: the
  // rules are checked against them (each must come out "Will slush").
  recipes: {
    max: [
      { id: 'margarita', name: 'Margarita', page: 16, setting: { preset: 'Cocktail', bars: 5 },
        items: [['limeade', 4, 'cup'], ['tequila', 1.5, 'cup'], ['water', 1, 'cup'], ['oj', 2 / 3, 'cup'], ['simple-syrup', 2 / 3, 'cup'], ['lime-juice', 0.25, 'cup']] },
      { id: 'frose', name: 'Strawberry frosé', page: 17, setting: { preset: 'Cocktail', bars: 5 },
        items: [['rose', 5, 'cup'], ['water', 1.5, 'cup'], ['fruit-puree', 1, 'cup'], ['lime-juice', 2, 'Tbsp']] },
      { id: 'latte', name: 'Frozen latte', page: 17, setting: { preset: 'Frappe', bars: 5 },
        items: [['cold-brew', 4.5, 'cup'], ['milk', 2.5, 'cup'], ['cream', 1, 'cup'], ['sugar', 2 / 3, 'cup']] },
      { id: 'blue-lemonade', name: 'Blue raspberry lemonade', page: 17, setting: { preset: 'Slushy', bars: 1 },
        items: [['lemonade', 64, 'oz']] }
    ],
    orig: [
      { id: 'margarita', name: 'Margarita', page: 12, setting: { preset: 'Cocktail' },
        items: [['limeade', 3, 'cup'], ['tequila', 1, 'cup'], ['water', 0.75, 'cup'], ['oj', 0.5, 'cup'], ['simple-syrup', 0.5, 'cup'], ['lime-juice', 3, 'Tbsp']] },
      { id: 'frose', name: 'Strawberry frosé', page: 13, setting: { preset: 'Wine' },
        items: [['rose', 4, 'cup'], ['water', 1, 'cup'], ['fruit-puree', 0.5, 'cup'], ['triple-sec', 0.25, 'cup']] },
      { id: 'latte', name: 'Frozen latte', page: 13, setting: { preset: 'Custom', temp: '29–29.8°F' },
        items: [['cold-brew', 3.75, 'cup'], ['milk', 1.5, 'cup'], ['cream', 0.75, 'cup'], ['sugar', 0.5, 'cup']] },
      { id: 'blue-raspberry', name: 'Blue raspberry slushy', page: 13, setting: { preset: 'Juice' },
        items: [['water', 4, 'cup'], ['simple-syrup', 1, 'cup']] }
    ]
  },

  // One-tap buttons under the search box.
  popular: ['cola', 'lemonade', 'oj', 'sweet-tea', 'rose', 'tequila', 'margarita-mix', 'simple-syrup', 'seltzer', 'water']
};
